import * as React from 'react';

import { useSetAtom } from 'jotai';

import { CameraButton } from '../../../_shared/LineItems/fields';
import { LoadStagedFieldProps } from '../_types';

import { $openLineItemPhotoModal } from '~/modules/trade/_state/lineItemPhoto.state';

export const CameraButtonField: React.FC<LoadStagedFieldProps> = ({
  lineItem,
  disabled,
  onFocus,
  onBlur,
}) => {
  const openPhotoModal = useSetAtom($openLineItemPhotoModal);

  const hasPhoto = Boolean(lineItem.photo?.previewUrl);

  const handleCameraPress = React.useCallback(() => {
    if (hasPhoto) {
      openPhotoModal(lineItem.id);
    }
  }, [lineItem.id, hasPhoto, openPhotoModal]);

  return (
    <div onFocus={onFocus} onBlur={onBlur} className="@CameraButtonField">
      <CameraButton
        onPress={handleCameraPress}
        disabled={disabled || !hasPhoto}
        hasPhoto={hasPhoto}
      />
    </div>
  );
};
